module.exports = __webpack_public_path__ + "static/scale-model-of-lexington-kentucky-e164c642ae5b3264d57a317992623eca.png";